import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-bulk-move .company { width: 11rem; }
			#sm-bulk-move .warehouse { width: 10rem; }
			#sm-bulk-move .location { width: 10rem; }
			#sm-bulk-move #reason { width: 22rem; }
		</style>
		<form id="sm-bulk-move" class="form" autocomplete="off">
			<datalist id="sm-bm-companies"></datalist>
			<datalist id="sm-bm-warehouses-t"></datalist>
			<datalist id="sm-bm-locations-t"></datalist>
			<div class="title">Movimentar seleção</div>
			<p class="mts muted" style="max-width:40rem">Para cada linha selecionada, move a quantidade do tipo de origem escolhido para o destino informado (mesma lógica de transações L/R/B).</p>
			<div class="fsb mtl">
				<label>De (origem)<sup>*</sup>
					<select id="source_stock" required>
						<option value="L">Disponível</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<label>Para (destino)<sup>*</sup>
					<select id="target_stock" required>
						<option value="L">Disponível</option>
						<option value="R">Reservado</option>
						<option value="B">Bloqueado</option>
					</select>
				</label>
				<label>Saída (se reserva)
					<input id="output_id" type="text">
				</label>
			</div>
			<div class="fsb mtm">
				<label>Empresa destino<sup>*</sup>
					<input id="target_warehouse_company_id" class="company" type="text" list="sm-bm-companies" required>
				</label>
				<label>Armazém destino<sup>*</sup>
					<input id="target_warehouse_id" class="warehouse" type="text" list="sm-bm-warehouses-t" required>
				</label>
				<label>Posição destino<sup>*</sup>
					<input id="target_location_id" class="location" type="text" list="sm-bm-locations-t" required>
				</label>
			</div>
			<div class="fsb mtm">
				<label>Natureza
					<input id="movement_kind" type="text" list="movement_kind_list">
				</label>
				<label>Motivo<sup>*</sup>
					<input id="reason" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Executar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-bulk-move',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#sm-bm-companies', 'companies', { labels: [ 'nick' ], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#source_stock' }, types: [ types.select() ] },
		{ properties: { selector: '#target_stock' }, types: [ types.select() ] },
		{ properties: { selector: '#output_id' }, types: [ types.number(0, 2) ] },
		{ properties: { selector: '#target_warehouse_company_id' }, types: [ types.pubsub(), types.datalist() ] },
		{ properties: { selector: '#target_warehouse_id' }, types: [ types.pubsub(), types.datalist(), types.observer('target_warehouse_company_id'), types.obs_load_options('warehouses') ] },
		{ properties: { selector: '#target_location_id' }, types: [ types.pubsub(), types.datalist(), types.observer([ 'target_warehouse_company_id', 'target_warehouse_id' ]), types.obs_load_options('locations', { labels: [ 'address' ], sep: '-', key: 'target_warehouse_company_id' }) ] },
		{ properties: { selector: '#movement_kind' }, types: [ types.opt_movement_kind(), types.datalist() ] },
		{ properties: { selector: '#reason' }, types: [] },
	],
};
